import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import API from "../config";


function OAuthCallback() {
  const navigate        = useNavigate();
  const [searchParams]  = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");
    const role  = searchParams.get("role");
    const error = searchParams.get("error");

    if (error || !token) {
      // ถ้า login ล้มเหลว → กลับไปหน้า login
      navigate("/login?error=oauth_failed");
      return;
    }

    // เก็บ token ลง localStorage เหมือน login ปกติ
    localStorage.setItem("token", token);
    localStorage.setItem("role", role || "user");

    // redirect ตาม role
    if (role === "admin") {
      navigate("/admin");
      return;
    }
    if (role === "staff") {        // ✅ เพิ่ม: staff → /calendar
      navigate("/calendar");
      return;
    }
    // user ปกติ — เช็ค profile status
    fetch(`${API}/api/profile-status`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((r) => r.json())
      .then(() => navigate("/rooms"))
      .catch(() => navigate("/rooms"));

  }, [navigate, searchParams]);

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#f2f2f2",
      fontFamily: "'Noto Sans Thai', sans-serif",
      color: "#555"
    }}>
      <div style={{ textAlign: "center" }}>
        <div style={{
          width: 40,
          height: 40,
          border: "4px solid #ddd",
          borderTop: "4px solid #333",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
          margin: "0 auto 16px"
        }} />
        <p>กำลังเข้าสู่ระบบ...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}

export default OAuthCallback;